import React, { useState } from "react";
// import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/ClipLoader"

import {
  Row,
  Col,
  CardTitle, 
  CardText,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import logo from "../Assets/SopanamWall.jpg";
import "../Components/Logo.css";
import { useNavigate } from "react-router-dom";
import { AvForm, AvInput } from "availity-reactstrap-validation-safe";
import axios from "axios";
import { BaseUrl } from "../Url";
import { useEffect } from "react";

function Login() {
  const [Loader, setLoader] = useState(false)
  const [Username, setusername] = useState("");
  const [Password, setPassword] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [Data, setData] = useState('')
  const [UserId, setUserId] = useState('')

  const navigate = useNavigate(); // Initialize useNavigate hook
  useEffect(() => {
    console.log("username:",Username);
    console.log("Password",Password);
  }, [Username,Password])

  // useEffect(() => {
  //   // Check the value of isLoggedIn in local storage
  //   const isLoggedIn = localStorage.getItem('isLoggedIn');

  //   if (!isLoggedIn || isLoggedIn !== 'true') {
  //     // If not logged in, deny access and navigate to a different route
  //     navigate('/');
  //   }
  // }, []);



 
    



    // const handleSubmit = () => {
    //   axios
    //     .post(
    //       BaseUrl +
    //         `api/Login/CheckSopanamUsers?Username=${Username}&Password=${Password}`
    //     )
    //     .then(function (response) {
    //       console.log(response.data);
  
    //       if (response.data.StatusCode === 404 && response.data.Result === 'InvalidUser') {
    //         // Show toast for invalid credentials
    //         toast.error('Invalid credentials. Please check your username and password.');
    //       } else {
    //         // Navigate to "/endowment" for valid credentials
    //         localStorage.setItem('isLoggedIn', 'true');
    //         navigate('/endowment');
    //       }
    //     })
    //     .catch(function (err) {
    //       console.log('login error', err);
    //     });
    // };
    useEffect(() => {
      console.log(Data);
     }, [Data])


    const handleSubmit = () => {
      setLoader(true)
      console.log("hi");
  
   
    
      
  
  
  
      axios
      .post(
        BaseUrl +
          `api/Login/CheckSopanamUsers?Username=${Username}&Password=${Password}`
      )
      .then(function (response) {
        console.log(response.data.UserId);
        setData(response.data)
        setUserId(response.data.UserId)

    
        if (response.data.StatusCode === 404 && response.data.Result === "InvalidUser") {
          // Show toast for invalid credentials
          toast.error("Invalid credentials. Please check your username and password.");
          setLoader(false)
        } else {
          // Navigate to "/endowment" for valid credentials
          setIsLoggedIn(true);
  
          localStorage.setItem('isLoggedIn', 'true');
          setLoader(false)
          // Navigate to "/endowment" for valid credentials
                 navigate("/endowment", { state: { UserId: response.data.UserId } });
                 console.log("id",{ state: { UserId: response.data.UserId } });
       }
      })
      .catch(function (err) {
        console.log("login error", err);
      });
  
      // navigate('/endowment');
    };

  return (
    <div className="auth-wrapper">
      <Row className="auth-inner m-0">
        <Col
          className="d-none d-lg-flex align-items-center login_bg"
          lg="8"
          sm="12"
          style={{ height: "100vh" }}
        >
          <div className="w-100 d-lg-flex">&nbsp;</div>
        </Col>
        <Col
          className="d-flex align-items-center auth-bg px-2 p-lg-5"
          lg="4"
          sm="12"
          id="login_area"
        >
          <Col className="px-xl-2 mx-auto" sm="8" md="6" lg="12">
            <CardTitle tag="h2" className="font-weight-bold mb-1">
              Welcome Back!
            </CardTitle>
            <CardText className="mb-2">Please login to Sopanam </CardText>
            <AvForm onValidSubmit={handleSubmit}>
              <AvInput
                name="username"
                type="text"
                onChange={(e)=>{setusername(e.target.value)}}
                value={Username}
                label="UserName:"
                placeholder="Username"
                
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Username is required",
                  },
                }}
              />

<AvInput
  name="password"
  type="password"
  label="Password:"
  onChange={(e) => { setPassword(e.target.value) }}
  value={Password}   
  placeholder="password"
  validate={{
    required: {
      value: true,
      errorMessage: "Password is required",
    },
  }}
/>

<Button type="submit" className="mt-3 btn3" variant="success" style={{backgroundColor:"#001766"}}>
             {Loader ? (<div class="d-flex align-items-center">
  <strong>Loading...</strong>
  <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
</div>):"Submit"} 
              </Button>
            </AvForm>
          </Col>
        </Col>
      </Row>
    </div>
  );
}

export default Login;
